import React from 'react';
import { ADMIN_ACCESS, USER_ACCESS } from './PermissionsRoutes';

const Forbidden = React.lazy(() => import('pages/common/Forbidden'))
const NotFound = React.lazy(() => import('pages/common/404'))

const ManagementSalary = React.lazy(() => import('pages/salary/ManagementSalary'))
const MySalary = React.lazy(() => import('pages/salary/MySalary'))
const RetirementPensionList = React.lazy(() => import('pages/salary/RetirementPensionList'))
const LeaveList = React.lazy(() => import('pages/salary/LeaveList'))
const PaymentList = React.lazy(() => import('pages/salary/PaymentList'))
const PaymentYearList = React.lazy(() => import('pages/salary/PaymentYearList'))
const ManagementSalaryEdit = React.lazy(() => import('pages/salary/ManagementSalaryEdit'))
const TransferList = React.lazy(() => import('pages/salary/TransferList'))
const LeavePaymentList = React.lazy(() => import('pages/salary/LeavePaymentList'))
const AccountBook = React.lazy(() => import('pages/salary/AccountBook'))
const LaborCostStatement = React.lazy(() => import('pages/salary/LaborCostStatement'))

const PF = '/salary'
const RoutesSalary = [
    { path: `${PF}`, exact: true, name: '급여관리' },
    { path: `${PF}/management`, exact: true, name: '급여관리', element: <ManagementSalary />, ...ADMIN_ACCESS },
    { path: `${PF}/my-salary`, exact: true, name: '내 급여명세서', element: <MySalary />, ...USER_ACCESS },
    { path: `${PF}/management/detail`, exact: true, name: '상세', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/management/write`, exact: true, name: '수정', element: <ManagementSalaryEdit />, ...ADMIN_ACCESS },
    { path: `${PF}/payment-list`, exact: true, name: '급여대장 조회', element: <PaymentList />, ...ADMIN_ACCESS },
    { path: `${PF}/payment-year-list`, exact: true, name: '연 급여 지급 내역 조회', element: <PaymentYearList />, ...ADMIN_ACCESS },
    { path: `${PF}/transfer`, exact: true, name: '급여이체현황', element: <TransferList />, ...ADMIN_ACCESS },
    { path: `${PF}/leave/list`, exact: true, name: '연차사용내역 조회', element: <LeaveList />, ...ADMIN_ACCESS },
    { path: `${PF}/leave/payment-list`, exact: true, name: '연차수당 조회', element: <LeavePaymentList />, ...ADMIN_ACCESS },
    { path: `${PF}/insurance-tax/retirement-pension`, exact: true, name: '퇴직연금내역', element: <RetirementPensionList />, ...ADMIN_ACCESS },
    { path: `${PF}/insurance-tax/retirement-pension/detail`, exact: true, name: '상세', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/account-book`, exact: true, name: '전표 조회', element: <AccountBook />, ...ADMIN_ACCESS },
    { path: `${PF}/labor-cost-statement`, exact: true, name: '노무비내역서', element: <LaborCostStatement />, ...ADMIN_ACCESS },

]

export default RoutesSalary;
